import { BusinessObjectPart, BusinessObjectPartContext, ModelBase, PropertyChangedJoinPoint, PropertyChangedJoinPointContext, Weaver } from '@skylab-shared/core';
import { KsefDocumentStatus, RateNP } from '@skylab-shared/dataModel';
import { propertyChangedJoinPointFilter } from '../../common/property-changed/property-changed-filter';
import { CommunityTransactionForSaleQuery } from '../../community-transaction/queries/community-transaction-for-sale.query-base';
import { getDefaultNPValues } from '../utils/sale-utils';

interface SaleDocumentReverseChargeAndNPModelPart extends ModelBase {
    communityTransactionId: number;
    ksefDocumentStatus?: KsefDocumentStatus;
    reverseCharge: boolean | null;
    rateNP: RateNP | null;
}

export class SaleDocumentReverseChargeAndNPBoPart extends BusinessObjectPart<SaleDocumentReverseChargeAndNPModelPart> {
    public constructor(weaver: Weaver) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<SaleDocumentReverseChargeAndNPModelPart>): Promise<void> {
        await super.initializeAsync(context);
        await this.bo.localContext.preload(CommunityTransactionForSaleQuery);
        this.registerCommunityTransactionDefaults();
    }

    private registerCommunityTransactionDefaults(): void {
        const applyDefaults = (context: PropertyChangedJoinPointContext) => {
            if (!context.oldValue) return;

            if (this.shouldSkipValidationForKsefState(this.bo.model.ksefDocumentStatus)) return;

            const transaction = this.bo.localContext.firstPreloaded(CommunityTransactionForSaleQuery, { id: this.bo.model.communityTransactionId });
            if (!transaction) return;

            const defaults = getDefaultNPValues(transaction.symbol);
            this.bo.model.reverseCharge ??= defaults.reverseCharge;
            this.bo.model.rateNP = defaults.rateNP;
        };

        this.registerListening(this.weaver.register(
            PropertyChangedJoinPoint,
            propertyChangedJoinPointFilter(this.bo)(this.modelType, ['communityTransactionId'])(applyDefaults)
        ));
    }

    private shouldSkipValidationForKsefState(ksefDocumentStatus: KsefDocumentStatus | undefined): boolean {
        return ksefDocumentStatus === KsefDocumentStatus.InProgress || ksefDocumentStatus === KsefDocumentStatus.Registered;
    }

    private isRequiredTransaction(transactionId: number): boolean {
        const transaction = this.bo.localContext.firstPreloaded(CommunityTransactionForSaleQuery, { id: transactionId });
        if (!transaction) return false;
        return ['ŚUPTK', 'DPTK'].includes(transaction.symbol);
    }
}